module.exports = "/_next/static/images/MaturityModelImageLg-dc6a0717f401bc9616e48d6661097ea3.png";